import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { JobCatalogTreeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import { translate } from 'modules/contracts/lib/translate'
import JobCatalogTreeSelector from 'modules/job_catalog/components/JobCatalogTreeSelector'

import RoleLevel from './RoleLevel'
import Salary from './Salary'
import { stepHasErrors } from './validator'

interface Props {
  form: Form
  translations: { [key: string]: string }
  step: number
  type: ContractFlowType
  setIsCurrentStepCompleted: (isCompleted: boolean) => void
  canEditPayrollPolicy?: boolean
  jobCatalogTrees?: JobCatalogTreeFragment[]
  jobCatalogTreeFeatureEnabled?: boolean
}

const RoleLevelSalary = ({
  form,
  translations,
  step,
  type,
  setIsCurrentStepCompleted,
  canEditPayrollPolicy = false,
  jobCatalogTrees,
  jobCatalogTreeFeatureEnabled,
}: Props) => {
  const salaryAmount = form.has('salary_amount') ? form.get('salary_amount').value : ''
  const salaryFrequency = form.has('salary_frequency') ? form.get('salary_frequency').value : ''
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setIsCurrentStepCompleted(!stepHasErrors(form, type))
  }, [
    form.get('job_catalog_role_id').value,
    form.get('job_catalog_level_id').value,
    salaryAmount,
    salaryFrequency,
    form.dirtyFieldsKeys.join(),
  ])
  /* eslint-enable react-hooks/exhaustive-deps */

  const onLevelSelect = (jobCatalogTreeNodeUuid: string | undefined) => {
    form.get('job_catalog_tree_node_uuid').set(jobCatalogTreeNodeUuid)
  }

  return (
    <Box gap="s32" paddingBottom="s40">
      <FormWrapper>
        <Text size="400" weight="medium" color="grey1000">
          {translate(translations, 'header')}
        </Text>
        {jobCatalogTreeFeatureEnabled && (
          <Box paddingTop="s24">
            <JobCatalogTreeSelector
              serializedTree={jobCatalogTrees?.[0]?.serializedTree || ''}
              onLevelSelect={onLevelSelect}
              selectedLevelId={form.get('job_catalog_tree_node_uuid').value}
            />
          </Box>
        )}
      </FormWrapper>
      <Box gap="s24">
        {!jobCatalogTreeFeatureEnabled && (
          <>
            <RoleLevel form={form} translations={translations} type={type} />
            <Salary
              step={step}
              type={type}
              form={form}
              translations={translations}
              canEditPayrollPolicy={canEditPayrollPolicy}
            />
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(RoleLevelSalary)
